import { render, staticRenderFns } from "./DoKoRestrictionOverview.vue?vue&type=template&id=049bb59e&scoped=true&"
import script from "./DoKoRestrictionOverview.vue?vue&type=script&lang=ts&"
export * from "./DoKoRestrictionOverview.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoRestrictionOverview.vue?vue&type=style&index=0&id=049bb59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049bb59e",
  null
  
)

export default component.exports